import React from 'react';

interface GuestPreviewQuickActionButtonProps {
  icon: React.ReactNode;
  label: string;
  url: string;
}

export const GuestPreviewQuickActionButton: React.FC<
  GuestPreviewQuickActionButtonProps
> = ({ icon, label, url }) => {
  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    await window.electron.ipcRenderer.invoke('open-external', url);
  };

  return (
    <button
      type="button"
      className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 transition-colors hover:border-pos-primary hover:text-pos-primary"
      aria-label={label}
      onClick={handleClick}
    >
      {icon}
    </button>
  );
};
